"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedManager = void 0;
const BinanceFeedHandler_1 = __importDefault(require("./feedhandlers/BinanceFeedHandler"));
const BitMEXFeedHandler_1 = require("./feedhandlers/BitMEXFeedHandler");
const KrakenFeedHandler_1 = __importDefault(require("./feedhandlers/KrakenFeedHandler"));
class FeedManager {
    constructor() {
        this._feedhandlers = new Map();
        this._orderBookEventHandlers = [];
        this._tradeEventHandlers = [];
        this.registerFeedhandler(new BitMEXFeedHandler_1.BitMEXFeedhandler());
        this.registerFeedhandler(new BinanceFeedHandler_1.default());
        this.registerFeedhandler(new KrakenFeedHandler_1.default());
    }
    registerFeedhandler(fh) {
        const exchange = fh.getExchange();
        if (this._feedhandlers.has(exchange)) {
            return new Error(`exchange: ${exchange} is already registered`);
        }
        // Feed manager acts as passthrough for upstream feed handlers
        fh.onOrderBookEvent((event) => this.publishOrderBookEvent(event));
        fh.onTradeEvent((event) => this.publishTradeEvent(event));
        this._feedhandlers.set(exchange, fh);
    }
    publishOrderBookEvent(event) {
        this._orderBookEventHandlers.forEach((fn) => fn(event));
    }
    publishTradeEvent(event) {
        this._tradeEventHandlers.forEach((fn) => fn(event));
    }
    onOrderBookEvent(fn) {
        this._orderBookEventHandlers.push(fn);
    }
    onTradeEvent(fn) {
        this._tradeEventHandlers.push(fn);
    }
    disconnect() {
        if (this._exchange === undefined)
            return;
        const fh = this._feedhandlers.get(this._exchange);
        fh === null || fh === void 0 ? void 0 : fh.disconnect();
    }
    connect(exchange, symbol) {
        const fh = this._feedhandlers.get(exchange);
        if (!fh) {
            throw new Error(`${exchange} does is not a managed feed`);
        }
        this._exchange = exchange;
        this._symbol = symbol;
        fh.connect(this._symbol);
    }
}
exports.FeedManager = FeedManager;
